import React from "react";
import { Checkbox, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { MimshakData } from "../../../interfaces/DTO/mimshakData";
import { formatCurrency } from "../../../utils/namesFormater";
import { formatHandlerCodeUniversal } from "../../../utils/handlerCodeUniversalFormatter";
import { isBasketNewFund, policyKey, productLabel } from "./quickActions";
import { displayPolicyNumber } from "../../../utils/manualProductTypeFormatter";

const rightAlignedText = { primary: { style: { textAlign: "right" as const } }, secondary: { style: { textAlign: "right" as const } } };

interface Props {
  policies: MimshakData[];
  onPick: (policy: MimshakData) => void;
  selected?: MimshakData | null;
  /** multi-select: a checkbox per policy */
  isChecked?: (policy: MimshakData) => boolean;
  isDisabled?: (policy: MimshakData) => boolean;
  emptyText?: string;
  /** under the list (e.g. "הצג הכל" when the policies are filtered) */
  footer?: React.ReactNode;
}

/** רשימת קופות לבחירה – סוג מוצר, יצרן, מספר פוליסה, יתרה והפקדה */
const PolicyPickList: React.FC<Props> = ({ footer, ...props }) => (
  <>
    <PolicyPickListItems {...props} />
    {footer}
  </>
);

const PolicyPickListItems: React.FC<Omit<Props, "footer">> = ({
  policies,
  onPick,
  selected,
  isChecked,
  isDisabled,
  emptyText = "אין קופות מתאימות",
}) => {
  if (policies.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", py: 2 }}>
        {emptyText}
      </Typography>
    );
  }
  return (
    <List dense sx={{ maxHeight: 360, overflowY: "auto" }}>
      {policies.map((p) => (
        <ListItemButton
          key={policyKey(p)}
          selected={!!selected && policyKey(selected) === policyKey(p)}
          disabled={isDisabled?.(p)}
          onClick={() => onPick(p)}
        >
          {isChecked && (
            <ListItemIcon sx={{ minWidth: 36 }}>
              <Checkbox edge="start" size="small" checked={isChecked(p)} tabIndex={-1} disableRipple />
            </ListItemIcon>
          )}
          <ListItemText
            primary={productLabel(p)}
            secondary={[
              formatHandlerCodeUniversal(p.handler_code),
              isBasketNewFund(p) ? "קופה חדשה" : displayPolicyNumber(p.policy_number),
              `יתרה ${formatCurrency(p.funds_sum || 0)}`,
              p.recurrent_deposit ? `הוראת קבע ${formatCurrency(p.recurrent_deposit)}` : null,
            ]
              .filter(Boolean)
              .join(" · ")}
            slotProps={rightAlignedText}
          />
        </ListItemButton>
      ))}
    </List>
  );
};

export default PolicyPickList;
